import type { Dict } from '../utils'

import { createContext } from '../utils'

const [ListProvider, useListContext] = createContext<Dict>({ isOptional: true })

export { ListProvider, useListContext }
